<template>
    <div>

        <rkm-area
            no-margin-top
            type="fieldset"
            title="Exames laboratoriais"
        >
            <rkm-row v-if="data.additionals.exibeBoxExameLaboratorialSolicitado">
                <rkm-col cols="12">
                    <rkm-area
                        :closed="!readonly"
                        background-color="primary"
                        title="Exames"
                        type="box"
                        no-margin-top
                    >
                        <BoxExameSolicitado :data="data" />
                    </rkm-area>
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="data.additionals.exibeBoxExameLaboratorialSolicitado && data.additionals.paciente.sexoId == enums.sexo.FEMININO">
                <rkm-col cols="12">
                    <rkm-area
                        :closed="!readonly"
                        background-color="primary"
                        title="Triagem neonatal"
                        type="box"
                    >
                        <BoxTriagemNeoNatal :data="data" />
                    </rkm-area>
                </rkm-col>
            </rkm-row>

            <rkm-area
                show-legend
            >
                <template slot="leading">
                    <rkm-button
                        @click="$refs.ModalExameComum.open()"
                        color="primary"
                    >
                        Adicionar exame laboratorial
                    </rkm-button>
                </template>

                <rkm-row>
                    <rkm-col cols="12">
                        <ListExameComum :data="data" />
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-area>

        <rkm-area
            no-margin-top
            type="fieldset"
            title="Exames de imagem"
        >
            <rkm-area no-margin-top show-legend>
                <template slot="leading">
                    <rkm-button
                        @click="$refs.ModalExameAltoCusto.open()"
                        color="primary"
                    >
                        Adicionar exames de imagem
                    </rkm-button>
                </template>

                <rkm-row>
                    <rkm-col cols="12">
                        <ListExameAltoCusto :data="data" />
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-area>


        <ModalExameComum
            :data="data"
            ref="ModalExameComum"
        />

        <ModalExameAltoCusto
            :data="data"
            ref="ModalExameAltoCusto"
        />
    </div>
</template>

<script>
// Components.
import ListExameAltoCusto from './components/alto-custo/List'
import ListExameComum from './components/comum/List'
import ModalExameAltoCusto from './components/alto-custo/Modal'
import ModalExameComum from './components/comum/Modal'
import BoxExameSolicitado from './components/comum/components/exame-solicitado/Index'
import BoxTriagemNeoNatal from './components/comum/components/triagem-neonatal/Index'

// Enums.
import sexo from '@/enums/cadastro/cidadao/sexo'

export default {
    components: {
        ListExameAltoCusto,
        ListExameComum,
        ModalExameAltoCusto,
        ModalExameComum,
        BoxExameSolicitado,
        BoxTriagemNeoNatal,
    },
    data: () => ({
        enums: {sexo},
    }),
    props: {
        data: {type: Object, required: true},
        readonly: {type: Boolean, default: false},
    },
}
</script>